module.exports = new Promise(resolve => {
                            //加载内部配置文件
                            const confurl = projectConfig.ACCOUNT_HEADER + '/config.js'
                            const scriptconf = document.createElement('script')
                            console.log(confurl,'加载内部配置文件')
                            scriptconf.src = confurl
                            document.head.appendChild(scriptconf);
                            scriptconf.onload = function () {
                                //加载入口文件
                                const remoteUrlWithVersion = projectConfig.ACCOUNT_HEADER + '/remoteEntry.js'
                                const script = document.createElement('script')
                                console.log(remoteUrlWithVersion,'配置加载路径')
                                script.src = remoteUrlWithVersion
                                script.onload = () => {
                                    const proxy = {
                                    get: (request) => window.HomeView.get(request),
                                    init: (arg) => {
                                        try {                               
                                        return window.HomeView.init(arg)
                                        } catch(e) {
                                        console.log('remote container already initialized')
                                        }
                                    }
                                    }
                                    resolve(proxy)
                                }
                                document.head.appendChild(script);
                            }   
                            })
                            ;